import {
    AssetType, testnetAddresses, mainnetAddresses, previewnetAddresses
} from 'tezoslendingplatformjs';
import fUSDtz from '../../assets/fusdtz.svg';
import fXTZ from '../../assets/fXTZ.svg';
import fUSDT from '../../assets/fusdt.svg';
import USDT from '../../assets/usdt.svg';

import ftzBTC from '../../assets/ftzBTC.svg';
import tzBTC from '../../assets/tzBTC.svg';

import USDtz from '../../assets/USDtz.svg';
import XTZ from '../../assets/XTZ.svg';

import stXTZ from '../../assets/stacy_logo.png';
import fstXTZ from '../../assets/fstXTZ.svg';
// import BTCtz from '../../assets/BTCtez.svg';
// import Ethtz from '../../assets/ETHtz.svg';
// import wtz from '../../assets/wtz.svg';
// import oxtz from '../../assets/oxtz.svg';
// import ctez from '../../assets/ctez.svg';
// import kUSD from '../../assets/kUSD.svg';
// import fBTCtz from '../../assets/fbtctz.svg';
// import fEthtz from '../../assets/fethtz.svg';
// import fCtez from '../../assets/fctez.svg';
// import fOXTZ from '../../assets/foxtz.svg';
// import fWTZ from '../../assets/fwtz.svg';

export const getAddresses = () => {
    switch (process.env.REACT_APP_ENV) {
    case 'shadownet':
        return testnetAddresses;
    case 'tezosx-previewnet':
        return previewnetAddresses;
    case 'mainnet':
        return mainnetAddresses;
    default:
        return mainnetAddresses;
    }
};

export const isRecoveryMode = () => Boolean(getAddresses().comptrollerDataSource);

const addresses = getAddresses();

export const tokens = [
    {
        title: 'XTZ',
        name: 'Tezos (Tez)',
        logo: XTZ,
        fLogo: fXTZ,
        banner: 'Tez',
        assetType: AssetType.XTZ,
        address: ''
    },
    {
        title: 'USDtz',
        name: 'USD Tez',
        logo: USDtz,
        fLogo: fUSDtz,
        banner: 'USDtz',
        assetType: AssetType.USD,
        address: addresses.underlying.USD?.address ?? ''
    },
    {
        title: 'USDt',
        name: 'USD Tether',
        logo: USDT,
        fLogo: fUSDT,
        banner: 'USDt',
        assetType: AssetType.USDT,
        address: addresses.underlying.USDT?.address ?? ''
    },
    process.env.REACT_APP_ENV !== 'tezosx-previewnet' && {
        title: 'tzBTC',
        name: 'tzBTC',
        logo: tzBTC,
        fLogo: ftzBTC,
        banner: 'tzBTC',
        assetType: AssetType.TZBTC,
        visibilityThreshold: 0.0000001,
        address: addresses.underlying.TZBTC?.address ?? ''
    },
    {
        title: 'stXTZ',
        name: 'stXTZ',
        logo: stXTZ,
        fLogo: fstXTZ,
        banner: 'stXTZ',
        assetType: AssetType.STXTZ,
        address: addresses.underlying.STXTZ?.address ?? ''
    }
    // {
    //     title: 'BTCtz', logo: BTCtz, fLogo: fBTCtz, banner: 'BTCtz', assetType: AssetType.BTC
    // },
    // {
    //     title: 'ETHtz', logo: Ethtz, fLogo: fEthtz, banner: 'ETH Tez', assetType: AssetType.ETH
    // },
    //   { title: 'kUSD', logo: kUSD, banner: 'kUSD', assetType: '' },
    // {
    //     title: 'CTez', logo: ctez, fLogo: fCtez, banner: 'CTez', assetType: AssetType.CTEZ
    // },
    // {
    //     title: 'WTZ', logo: wtz, fLogo: fWTZ, banner: 'WTZ', assetType: AssetType.WTZ // TODO:  update fToken for  WTZ
    // }
].filter(Boolean);
export const tokenColor = {
    XTZ: 'rgb(51,145,246)',
    USDtz: 'rgb(24,157,163)',
    USDt: 'rgb(65 145 146)',
    tzBTC: 'rgb(20,89,255)',
    stXTZ: '#2B62F8'
    // ETHtz: '#662F9D',
    // BTCtz: '#F2991A',
    // oXTZ: '#B52B31',
    // WTZ: '#0C2C93'
    // CTEZ: '#2B62F8'
};
